module.exports = __webpack_public_path__ + "static/img/54-3.1411229.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/54-3.jpg
// module id = Ov56
// module chunks = 0